import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import swal from 'sweetalert2';
import { getBaseGroups, deleteBaseGroup, getBaseGroup, updateBaseGroup, createBaseGroup, clearActiveBaseGroup, setActiveBaseGroup } from 'actions/basegroups';
import BaseGroupForm from 'containers/BaseGroups/Form/BaseGroupForm';
import { Button, Checkbox, Flex, Select, Icon } from '@haldor/ui';
import { Spinner } from 'UI';

var AssignmentTaskSelect = /*#__PURE__*/function (_Component) {
  _inherits(AssignmentTaskSelect, _Component);

  var _super = _createSuper(AssignmentTaskSelect);

  /* Class setup */
  function AssignmentTaskSelect(props) {
    var _this;

    _classCallCheck(this, AssignmentTaskSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.section != null) {
        var _this$props$section;

        _this.props.getBaseGroups((_this$props$section = _this.props.section) === null || _this$props$section === void 0 ? void 0 : _this$props$section.id);
      }

      if (_this.props.input != null && _this.state.tasks.length > 0) {
        _this.props.input.onChange(_this.state.tasks);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.section != null && nextProps.section != _this.props.section) {
        var _nextProps$section, _this$props$section2, _nextProps$section2;

        _this.props.getBaseGroups((_nextProps$section = nextProps.section) === null || _nextProps$section === void 0 ? void 0 : _nextProps$section.id);

        if (_this.props.copyMode && ((_this$props$section2 = _this.props.section) === null || _this$props$section2 === void 0 ? void 0 : _this$props$section2.id) != ((_nextProps$section2 = nextProps.section) === null || _nextProps$section2 === void 0 ? void 0 : _nextProps$section2.id)) {
          _this.props.clearActiveBaseGroup();

          var tasks = [];

          _this.setState({
            tasks: tasks,
            units: [],
            selectedBaseGroup: ''
          }, function () {
            if (_this.props.input != null) {
              _this.props.input.onChange(tasks);
            }
          });
        }
      }

      if (nextProps.groupEnabled != null && nextProps.groupEnabled != _this.groupAssignment) {
        _this.groupAssignment = nextProps.groupEnabled;

        _this.props.clearActiveBaseGroup();

        _this.setState({
          tasks: [],
          units: [],
          selectedBaseGroup: ''
        }, function () {
          if (_this.props.input != null) {
            _this.props.input.onChange(_this.state.tasks);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearActiveBaseGroup();
    });

    _defineProperty(_assertThisInitialized(_this), "_loadTasksAsUnits", function () {
      var units = [];

      _this.state.tasks.forEach(function (task) {
        var unit = {
          title: task.groupName,
          memberships: []
        };
        task.students.forEach(function (student) {
          unit.memberships.push({
            userId: student.userId,
            user: student
          });
        });
        units.push(unit);
      });

      if (units.length > 0) {
        _this.props.setActiveBaseGroup({
          title: '',
          units: units
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onBaseGroupSelect", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var _this$props$active, _this$props$active$un, _this$props$active2;

        var activeStudents;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(event.target.value == null || event.target.value == '')) {
                  _context.next = 3;
                  break;
                }

                _this.setState({
                  selectedBaseGroup: ''
                });

                return _context.abrupt("return", false);

              case 3:
                _this.setState({
                  loading: true,
                  selectedBaseGroup: event.target.value
                });

                _context.next = 6;
                return _this.props.getBaseGroup(event.target.value);

              case 6:
                activeStudents = [];
                (_this$props$active = _this.props.active) === null || _this$props$active === void 0 ? void 0 : (_this$props$active$un = _this$props$active.units) === null || _this$props$active$un === void 0 ? void 0 : _this$props$active$un.forEach(function (unit) {
                  var _unit$memberships;

                  (_unit$memberships = unit.memberships) === null || _unit$memberships === void 0 ? void 0 : _unit$memberships.forEach(function (membership) {
                    activeStudents.push(membership === null || membership === void 0 ? void 0 : membership.user);
                  });
                });

                _this.setState({
                  loading: false,
                  activeStudents: activeStudents,
                  units: (_this$props$active2 = _this.props.active) === null || _this$props$active2 === void 0 ? void 0 : _this$props$active2.units
                }, function () {
                  _this.onUpdate();
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onBaseGroupSubmit", function (event) {
      var _this$props = _this.props,
          translate = _this$props.translate,
          section = _this$props.section;
      event.preventDefault();
      return new Promise(function (resolve) {
        var values = {
          units: _this.state.units,
          sectionId: section.id
        };
        swal.fire({
          title: translate('name-basegroup'),
          text: translate('name-basegroup-explain'),
          input: 'text',
          showCancelButton: true,
          cancelButtonText: translate('Cancel'),
          confirmButtonText: translate('save')
        }).then( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!(response.value != null)) {
                      _context2.next = 10;
                      break;
                    }

                    values.title = response.value;

                    if (!(values.id == null)) {
                      _context2.next = 7;
                      break;
                    }

                    _context2.next = 5;
                    return _this.props.createBaseGroup(values);

                  case 5:
                    _context2.next = 9;
                    break;

                  case 7:
                    _context2.next = 9;
                    return _this.props.updateBaseGroup(values);

                  case 9:
                    resolve(1);

                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBaseGroupUpdate", function (units) {
      _this.setState({
        units: units
      }, function () {
        _this.onUpdate();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentSelect", function (student) {
      var activeStudents = _this.state.activeStudents;

      var studentIndex = _this.state.activeStudents.findIndex(function (activeStudent) {
        return activeStudent.userId == student.userId;
      });

      if (studentIndex > -1) {
        activeStudents.splice(studentIndex, 1);
      } else {
        activeStudents.push(student);
      }

      _this.setState({
        activeStudents: activeStudents
      }, function () {
        _this.onUpdate();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdate", function () {
      var tasks = [];

      _this.state.units.forEach(function (unit) {
        var _unit$memberships2;

        var task = {
          groupName: unit.title,
          assignedTo: '',
          students: []
        };
        (_unit$memberships2 = unit.memberships) === null || _unit$memberships2 === void 0 ? void 0 : _unit$memberships2.forEach(function (member) {
          task.assignedTo = task.assignedTo + member.userId + ';';
          task.students.push(member.user);
        });
        tasks.push(task);
      });

      if (_this.props.input != null) {
        _this.props.input.onChange(tasks);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearSelection", function () {
      _this.props.clearActiveBaseGroup();

      _this.setState({
        units: [],
        activeStudents: [],
        selectedBaseGroup: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleTaskDeletion", function (task) {
      var tasks = JSON.parse(JSON.stringify(_this.state.tasks));
      tasks[task.index].markedForDeletion = !task.markedForDeletion;

      _this.setState({
        tasks: tasks
      }, function () {
        if (_this.props.onChange != null) {
          _this.props.onChange(tasks);
        }

        if (_this.props.input != null) {
          _this.props.input.onChange(tasks);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "editTaskTitle", function (task) {
      var translate = _this.props.translate;
      var tasks = _this.state.tasks;
      swal.fire({
        title: translate('edit-name'),
        text: translate('name'),
        input: 'text',
        inputValue: task.groupName,
        showCancelButton: true,
        cancelButtonText: translate('Cancel'),
        confirmButtonText: translate('save'),
        preConfirm: function preConfirm(value) {
          if (value.length > 50) {
            return swal.showValidationMessage(translate('Group name can not be longer than 50 characters'));
          }

          return undefined;
        }
      }).then(function (response) {
        if (response.value != null) {
          task.groupName = response.value;

          _this.setState({
            tasks: tasks
          }, function () {
            _this.onUpdate();

            if (_this.props.input != null) {
              _this.props.input.onChange(tasks);
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeTaskObject", function (taskIndex) {
      var tasks = _this.state.tasks;
      var task = tasks.find(function (task) {
        return task.index == taskIndex;
      });

      if (task != null) {
        if (task.id != -1) {
          task.markedForDeletion = !task.markedForDeletion;
        } else {
          tasks.splice(1, taskIndex);
        }

        task.students.forEach(function (student) {
          _this.removeStudentFromTask(student.id, taskIndex);
        });

        _this.setState({
          tasks: tasks
        }, function () {
          if (_this.props.input != null) {
            _this.props.input.onChange(_this.state.tasks);
          }

          if (_this.props.onChange != null) {
            _this.props.onChange(_this.state.tasks);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeStudentFromTask", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(studentId, taskIndex) {
        var tasks, task, studentsArr;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tasks = _this.state.tasks;
                task = tasks.find(function (task) {
                  return task.index == taskIndex;
                });

                if (task != null) {
                  if (task.assignedTo.indexOf(studentId) > -1) {
                    task.assignedTo = task.assignedTo.replace(studentId + ';', '');
                    task.assignedTo = task.assignedTo.replace(studentId, '');
                    studentsArr = task.students.filter(function (x) {
                      return x.userId != studentId;
                    });
                    task.students = studentsArr;
                  }

                  _this.setState({
                    tasks: tasks
                  }, function () {
                    _this.onUpdate();

                    if (_this.props.input != null) {
                      _this.props.input.onChange(_this.state.tasks);
                    }

                    if (_this.props.onChange != null) {
                      _this.props.onChange(_this.state.tasks);
                    }
                  });
                }

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "addStudentAsTask", function (student) {
      var tasks = JSON.parse(JSON.stringify(_this.state.tasks));
      var studentTask = tasks.findIndex(function (task) {
        return task.groupName == student.firstName + ' ' + student.lastName;
      });

      if (studentTask > -1) {
        tasks[studentTask].markedForDeletion = false;
      } else {
        tasks.push({
          groupName: student.firstName + ' ' + student.lastName,
          assignedTo: student.userId,
          students: [student],
          id: -1,
          index: _this.state.tasks.length + 1
        });
      }

      _this.setState({
        tasks: tasks
      });

      if (_this.props.input != null) {
        _this.props.input.onChange(tasks);
      }

      if (_this.props.onChange != null) {
        _this.props.onChange(tasks);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addStudentOnTask", function (student, taskIndex) {
      var tasks = _this.state.tasks;
      var task = tasks.find(function (task) {
        return task.index == taskIndex;
      });

      if (task != null) {
        if (task.assignedTo != null) {
          if (!task.assignedTo.endsWith(';')) {
            task.assignedTo = task.assignedTo + ';';
          }

          task.assignedTo = task.assignedTo + student.userId + ';';
        } else {
          task.assignedTo = student.userId + ';';
        }

        task.students.push(student);
      }

      _this.setState({
        tasks: tasks
      }, function () {
        _this.onUpdate();

        if (_this.props.input.onChange != null) {
          _this.props.input.onChange(_this.state.tasks);
        }

        if (_this.props.onChange != null) {
          _this.props.onChange(_this.state.tasks);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addTaskGroup", function (e) {
      e.preventDefault();
      var tasks = _this.state.tasks;
      var largest = 1;
      tasks.forEach(function (task) {
        var num = parseInt(task.groupName.replace(/^\D+/g, ''));

        if (num > largest) {
          largest = num;
        }
      });
      var task = {
        groupName: _this.props.translate('group') + ' ' + (largest + 1),
        assignedTo: '',
        students: [],
        id: -1,
        index: _this.state.tasks.length
      };
      tasks.push(task);

      _this.setState({
        tasks: tasks
      }, function () {
        _this.onUpdate();

        if (_this.props.input != null) {
          _this.props.input.onChange(tasks);
        }
      });

      return tasks;
    });

    _defineProperty(_assertThisInitialized(_this), "renderEditMode", function () {
      var unassignedStudents = _this.props.section.students.filter(function (student) {
        var foundInTasks = _this.state.tasks.find(function (task) {
          if (task.assignedTo == null) {
            return false;
          }

          var foundInStudents = task.students.find(function (taskStudent) {
            return taskStudent.userId == student.userId;
          });
          return task.assignedTo.indexOf(student.userId) > -1 || foundInStudents != null;
        });

        return foundInTasks == null;
      }).sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      });

      var options = [];

      _this.state.tasks.forEach(function (task) {
        if (!task.markedForDeletion) {
          options.push({
            value: task.index,
            label: task.groupName
          });
        }
      });

      return /*#__PURE__*/React.createElement("div", {
        className: "basegroups display"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: _this.addTaskGroup
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), _this.props.translate('new-group')), _this.state.tasks.map(function (task, index) {
        var _task$assessmentTypeR;

        if (task.markedForDeletion) {
          return null;
        }

        var assessments = (_task$assessmentTypeR = task.assessmentTypeRelationships) === null || _task$assessmentTypeR === void 0 ? void 0 : _task$assessmentTypeR.find(function (atr) {
          return atr.assessmentId != null;
        });
        return /*#__PURE__*/React.createElement("div", {
          key: task.id + '-' + index,
          className: "unit"
        }, /*#__PURE__*/React.createElement("span", {
          className: "title"
        }, assessments ? /*#__PURE__*/React.createElement(Select, {
          onChange: function onChange(value) {
            if (value == 'rename') {
              _this.editTaskTitle(task);
            }
          },
          options: [{
            value: 'rename',
            label: _this.props.translate('edit-name')
          }]
        }, task.groupName) : /*#__PURE__*/React.createElement(Select, {
          onChange: function onChange(value) {
            if (value == 'remove') {
              _this.removeTaskObject(task.index);
            }

            if (value == 'rename') {
              _this.editTaskTitle(task);
            }
          },
          options: [{
            value: 'rename',
            label: _this.props.translate('edit-name')
          }, {
            value: 'remove',
            label: _this.props.translate('Remove')
          }]
        }, task.groupName)), task.students.sort(function (a, b) {
          return a.lastName.localeCompare(b.lastName);
        }).map(function (student) {
          return /*#__PURE__*/React.createElement("div", {
            key: student.userId
          }, student.firstName + ' ' + student.lastName, /*#__PURE__*/React.createElement("div", {
            className: "float--right"
          }, /*#__PURE__*/React.createElement(Select, {
            onChange: function onChange(value) {
              _this.removeStudentFromTask(student.id, task.index);

              if (value != 'remove') {
                _this.addStudentOnTask(student, value);
              }
            },
            options: [].concat(options, [{
              value: 'remove',
              label: _this.props.translate('Remove')
            }])
          }, task.groupName)), /*#__PURE__*/React.createElement("div", {
            className: "clearfix"
          }));
        }));
      }), unassignedStudents.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "unit"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('unassigned-students')), unassignedStudents.map(function (student) {
        return /*#__PURE__*/React.createElement("div", {
          key: student.userId
        }, student.firstName, " ", student.lastName, /*#__PURE__*/React.createElement("div", {
          className: "float--right"
        }, /*#__PURE__*/React.createElement(Select, {
          onChange: function onChange(value) {
            return _this.addStudentOnTask(student, value);
          },
          options: options
        }, _this.props.translate('select-group'))), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        }));
      })) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderRegularEditMode", function () {
      var unassignedStudents = _this.props.section.students.filter(function (student) {
        var studentTask = _this.state.tasks.find(function (task) {
          return task.groupName == student.firstName + ' ' + student.lastName;
        });

        var deleted = studentTask != null ? studentTask.markedForDeletion : false;
        return studentTask == null || deleted;
      }).sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      });

      return /*#__PURE__*/React.createElement("div", {
        className: "basegroups display"
      }, /*#__PURE__*/React.createElement("div", {
        className: "unit"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('assigned-students')), _this.state.tasks.sort(function (a, b) {
        return a.groupName.split(' ').pop().localeCompare(b.groupName.split(' ').pop());
      }).map(function (task, index) {
        var _task$assessmentTypeR2;

        if (task.markedForDeletion) {
          return null;
        }

        var assessments = (_task$assessmentTypeR2 = task.assessmentTypeRelationships) === null || _task$assessmentTypeR2 === void 0 ? void 0 : _task$assessmentTypeR2.find(function (atr) {
          return atr.assessmentId != null;
        });
        return /*#__PURE__*/React.createElement("div", {
          key: 'task-' + index,
          style: {
            marginBottom: '.2rem'
          }
        }, task.groupName, /*#__PURE__*/React.createElement("div", {
          className: "float--right"
        }, assessments ? /*#__PURE__*/React.createElement("div", {
          style: {
            cursor: 'not-allowed'
          }
        }, _this.props.translate('Remove')) : /*#__PURE__*/React.createElement("div", {
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick(event) {
            return _this.toggleTaskDeletion(task);
          }
        }, _this.props.translate('Remove'))), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        }));
      })), unassignedStudents.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "unit"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('unassigned-students')), unassignedStudents.map(function (student) {
        return /*#__PURE__*/React.createElement("div", {
          key: student.userId,
          style: {
            marginBottom: '.2rem'
          }
        }, student.firstName, " ", student.lastName, /*#__PURE__*/React.createElement("div", {
          className: "float--right"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick(event) {
            return _this.addStudentAsTask(student);
          }
        }, _this.props.translate('Add'))), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        }));
      })) : null);
    });

    var _tasks = [];
    var editing = false;

    if (props.input.value != null && props.input.value !== '') {
      _tasks = JSON.parse(JSON.stringify(props.input.value));

      _tasks.forEach(function (task, index) {
        return task.index = index;
      });

      editing = true;
    }

    _this.state = {
      tasks: _tasks,
      activeStudents: [],
      units: [],
      selectedBaseGroup: '',
      loading: false
    };
    _this.editing = editing;
    _this.groupAssignment = _this.props.groupEnabled;
    return _this;
  }
  /* Lifecycle methods */


  _createClass(AssignmentTaskSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.section == null) {
        return /*#__PURE__*/React.createElement("div", null, this.props.translate('select-a-group-to-continue'));
      }

      if (this.editing && this.groupAssignment && !this.props.copyMode) {
        return this.renderEditMode();
      }

      if (this.editing && !this.groupAssignment) {
        return this.renderRegularEditMode();
      }

      var baseGroupFormActions = [{
        value: this.props.translate('save-subgroup'),
        onClick: this.onBaseGroupSubmit,
        type: 'secondary'
      }];
      return /*#__PURE__*/React.createElement("div", {
        className: "basegroups select"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        },
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        style: {
          padding: '.85rem 1rem'
        },
        value: this.state.selectedBaseGroup,
        onChange: this.onBaseGroupSelect
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, this.props.translate('select-basegroup')), this.props.baseGroups != null ? this.props.baseGroups.map(function (baseGroup) {
        return /*#__PURE__*/React.createElement("option", {
          value: baseGroup.id,
          key: baseGroup.id
        }, baseGroup.title);
      }) : null)), this.props.active != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 0,
          marginLeft: '1.25rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        style: {
          whiteSpace: 'nowrap'
        },
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.clearSelection();
        }
      }, this.props.translate('reset'))) : null)), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(BaseGroupForm, {
        onUpdate: this.onBaseGroupUpdate,
        actions: this.state.selectedBaseGroup != '' ? null : baseGroupFormActions,
        section: this.props.section,
        baseGroup: this.props.active,
        hideTitle: true
      }));
    }
  }]);

  return AssignmentTaskSelect;
}(Component);

_defineProperty(AssignmentTaskSelect, "defaultProps", {
  copyMode: false,
  groupEnabled: false
});

function mapStateToProps(state) {
  return {
    active: state.BaseGroups.baseGroup,
    baseGroups: state.BaseGroups.baseGroups,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  getBaseGroups: getBaseGroups,
  getBaseGroup: getBaseGroup,
  clearActiveBaseGroup: clearActiveBaseGroup,
  createBaseGroup: createBaseGroup,
  updateBaseGroup: updateBaseGroup,
  setActiveBaseGroup: setActiveBaseGroup
})(AssignmentTaskSelect);